import { REACT_APP_API_URL } from '../../setup/config'
import axios, { handleApiError } from '../axios';


export const getCompanyBillAddrs = async (data) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/company-bill-addrs/`,data)
        return await response.data;
    } catch (error) {
        console.log("getCompanyBillAddrs - error", error)
        return handleApiError(error)
    }
}

export const getCompanyBillAddrDataById = async (billAddrId) => {
    try {
        const response = await axios.get(`${REACT_APP_API_URL}/company-bill-addrs/${billAddrId}`,)
        return await response.data;
    } catch (error) {
        console.log("getCompanyBillAddrById - error", error)
        return handleApiError(error)
    }
}

export const addCompanyBillAddrData = async (data) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/company-bill-addrs/create`, data)
        return await response.data;
    } catch (error) {
        console.log("addCompanyBillAddr - error", error)
        return handleApiError(error)
    }
}

export const getCompanyBillAddrsByPanCode = async (data) =>  {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/company-bill-addrs/pancode`, data)
        return await response.data
    } catch (error) {
        console.log("getCompanyBillAddrsByPanCode - error", error)
        return handleApiError(error)
    }
}

